import { IShadows } from "../types";

export const shadows: IShadows = {
    "shadow-x-small-default": [
        {
            color: "rgba(83, 86, 88, 0.16)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.24)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        }
    ],
    "shadow-x-small-secondary": [
        {
            color: "rgba(128, 71, 20, 0.16)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.24)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        }
    ],
    "shadow-x-small-tertiary": [
        {
            color: "rgba(30, 83, 163, 0.16)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.24)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        }
    ],
    "shadow-x-small-success": [
        {
            color: "rgba(50, 96, 23, 0.16)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.24)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        }
    ],
    "shadow-x-small-error": [
        {
            color: "rgba(155, 48, 34, 0.16)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.24)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        }
    ],
    "shadow-x-small-focused-default": [
        {
            color: "rgba(234, 236, 237, 1)",
            x: "0",
            y: "0",
            blur: "0",
            spread: "4"
        },
        {
            color: "rgba(83, 86, 88, 0.16)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.24)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        }
    ],
    "shadow-x-small-focused-secondary": [
        {
            color: "rgba(251, 236, 162, 1)",
            x: "0",
            y: "0",
            blur: "0",
            spread: "4"
        },
        {
            color: "rgba(128, 71, 20, 0.16)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.24)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        }
    ],
    "shadow-x-small-focused-tertiary": [
        {
            color: "rgba(220, 238, 254, 1)",
            x: "0",
            y: "0",
            blur: "0",
            spread: "4"
        },
        {
            color: "rgba(30, 83, 163, 0.16)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.24)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        }
    ],
    "shadow-x-small-focused-success": [
        {
            color: "rgba(209, 249, 165, 1)",
            x: "0",
            y: "0",
            blur: "0",
            spread: "4"
        },
        {
            color: "rgba(50, 96, 23, 0.16)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.24)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        }
    ],
    "shadow-x-small-focused-error": [
        {
            color: "rgba(254, 232, 227, 1)",
            x: "0",
            y: "0",
            blur: "0",
            spread: "4"
        },
        {
            color: "rgba(155, 48, 34, 0.16)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.24)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        }
    ],
    "shadow-small-default": [
        {
            color: "rgba(83, 86, 88, 0.16)",
            x: "0",
            y: "1",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.24)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        }
    ],
    "shadow-small-secondary": [
        {
            color: "rgba(128, 71, 20, 0.16)",
            x: "0",
            y: "1",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.24)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        }
    ],
    "shadow-small-tertiary": [
        {
            color: "rgba(30, 83, 163, 0.16)",
            x: "0",
            y: "1",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.24)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        }
    ],
    "shadow-small-success": [
        {
            color: "rgba(50, 96, 23, 0.16)",
            x: "0",
            y: "1",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.24)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        }
    ],
    "shadow-small-error": [
        {
            color: "rgba(155, 48, 34, 0.16)",
            x: "0",
            y: "1",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.24)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        }
    ],
    "shadow-regular-default": [
        {
            color: "rgba(83, 86, 88, 0.08)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.16)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.24)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        }
    ],
    "shadow-regular-secondary": [
        {
            color: "rgba(128, 71, 20, 0.08)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.16)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.24)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        }
    ],
    "shadow-regular-tertiary": [
        {
            color: "rgba(30, 83, 163, 0.08)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.16)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.24)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        }
    ],
    "shadow-regular-success": [
        {
            color: "rgba(50, 96, 23, 0.08)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.16)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.24)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        }
    ],
    "shadow-regular-error": [
        {
            color: "rgba(155, 48, 34, 0.08)",
            x: "0",
            y: "0",
            blur: "1",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.16)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.24)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        }
    ],
    "shadow-medium-default": [
        {
            color: "rgba(83, 86, 88, 0.08)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.16)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.24)",
            x: "0",
            y: "8",
            blur: "16",
            spread: "0"
        }
    ],
    "shadow-medium-secondary": [
        {
            color: "rgba(128, 71, 20, 0.08)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.06)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.24)",
            x: "0",
            y: "8",
            blur: "16",
            spread: "0"
        }
    ],
    "shadow-medium-tertiary": [
        {
            color: "rgba(30, 83, 163, 0.08)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.16)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.24)",
            x: "0",
            y: "8",
            blur: "16",
            spread: "0"
        }
    ],
    "shadow-medium-success": [
        {
            color: "rgba(50, 96, 23, 0.08)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.16)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.24)",
            x: "0",
            y: "8",
            blur: "16",
            spread: "0"
        }
    ],
    "shadow-medium-error": [
        {
            color: "rgba(155, 48, 34, 0.08)",
            x: "0",
            y: "1",
            blur: "2",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.16)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.24)",
            x: "0",
            y: "8",
            blur: "16",
            spread: "0"
        }
    ],
    "shadow-large-default": [
        {
            color: "rgba(83, 86, 88, 0.08)",
            x: "0",
            y: "1",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.16)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.24)",
            x: "0",
            y: "12",
            blur: "24",
            spread: "0"
        }
    ],
    "shadow-large-secondary": [
        {
            color: "rgba(128, 71, 20, 0.08)",
            x: "0",
            y: "1",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.16)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.24)",
            x: "0",
            y: "12",
            blur: "24",
            spread: "0"
        }
    ],
    "shadow-large-tertiary": [
        {
            color: "rgba(30, 83, 163, 0.08)",
            x: "0",
            y: "1",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.16)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.24)",
            x: "0",
            y: "12",
            blur: "24",
            spread: "0"
        }
    ],
    "shadow-large-success": [
        {
            color: "rgba(50, 96, 23, 0.08)",
            x: "0",
            y: "1",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.16)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.24)",
            x: "0",
            y: "12",
            blur: "24",
            spread: "0"
        }
    ],
    "shadow-large-error": [
        {
            color: "rgba(155, 48, 34, 0.08)",
            x: "0",
            y: "1",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.16)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.24)",
            x: "0",
            y: "12",
            blur: "24",
            spread: "0"
        }
    ],
    "shadow-x-large-default": [
        {
            color: "rgba(83, 86, 88, 0.08)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.16)",
            x: "0",
            y: "4",
            blur: "12",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.24)",
            x: "0",
            y: "16",
            blur: "32",
            spread: "0"
        }
    ],
    "shadow-x-large-secondary": [
        {
            color: "rgba(128, 71, 20, 0.08)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.16)",
            x: "0",
            y: "4",
            blur: "12",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.24)",
            x: "0",
            y: "16",
            blur: "32",
            spread: "0"
        }
    ],
    "shadow-x-large-tertiary": [
        {
            color: "rgba(30, 83, 163, 0.08)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.16)",
            x: "0",
            y: "4",
            blur: "12",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.24)",
            x: "0",
            y: "16",
            blur: "32",
            spread: "0"
        }
    ],
    "shadow-x-large-success": [
        {
            color: "rgba(50, 96, 23, 0.08)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.16)",
            x: "0",
            y: "4",
            blur: "12",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.24)",
            x: "0",
            y: "16",
            blur: "32",
            spread: "0"
        }
    ],
    "shadow-x-large-error": [
        {
            color: "rgba(155, 48, 34, 0.08)",
            x: "0",
            y: "2",
            blur: "4",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.16)",
            x: "0",
            y: "4",
            blur: "12",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.24)",
            x: "0",
            y: "16",
            blur: "32",
            spread: "0"
        }
    ],
    "shadow-xx-large-default": [
        {
            color: "rgba(83, 86, 88, 0.08)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.16)",
            x: "0",
            y: "8",
            blur: "16",
            spread: "0"
        },
        {
            color: "rgba(83, 86, 88, 0.24)",
            x: "0",
            y: "24",
            blur: "48",
            spread: "0"
        }
    ],
    "shadow-xx-large-secondary": [
        {
            color: "rgba(128, 71, 20, 0.08)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.16)",
            x: "0",
            y: "8",
            blur: "16",
            spread: "0"
        },
        {
            color: "rgba(128, 71, 20, 0.24)",
            x: "0",
            y: "24",
            blur: "48",
            spread: "0"
        }
    ],
    "shadow-xx-large-tertiary": [
        {
            color: "rgba(30, 83, 163, 0.08)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.16)",
            x: "0",
            y: "8",
            blur: "16",
            spread: "0"
        },
        {
            color: "rgba(30, 83, 163, 0.24)",
            x: "0",
            y: "24",
            blur: "48",
            spread: "0"
        }
    ],
    "shadow-xx-large-success": [
        {
            color: "rgba(50, 96, 23, 0.08)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.16)",
            x: "0",
            y: "8",
            blur: "16",
            spread: "0"
        },
        {
            color: "rgba(50, 96, 23, 0.24)",
            x: "0",
            y: "24",
            blur: "48",
            spread: "0"
        }
    ],
    "shadow-xx-large-error": [
        {
            color: "rgba(155, 48, 34, 0.08)",
            x: "0",
            y: "4",
            blur: "8",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.16)",
            x: "0",
            y: "8",
            blur: "16",
            spread: "0"
        },
        {
            color: "rgba(155, 48, 34, 0.24)",
            x: "0",
            y: "24",
            blur: "48",
            spread: "0"
        }
    ]
};
